import _ from 'lodash';
import { createSelector } from 'reselect';

const selectFilters = state => state.filters;

export const getFilterValueSelector = ({ filtersGroupId, filterId }) =>
  createSelector(selectFilters, filters => _.get(filters, [filtersGroupId, filterId]));

export const getFiltersGroupValuesSelector = ({ filtersGroupId }) =>
  createSelector(selectFilters, filters => _.get(filters, [filtersGroupId]));
